import React, {
    useMemo,
    useState } from 'react';
import strip from 'strip';
import PropTypes from 'prop-types';
import Main from 'ripple/Containers/Main';

function SocialSharePage({ viewer }) {
    const { share } = viewer;
    const { medium } = share || {};
    const assetType = useMemo(
        () => (medium?.asset?.type.toLowerCase() === 'video' ? 'video' : 'image'),
        [medium],
      );
    const metaTitle = useMemo(
        () => `${strip(medium?.event?.community.name)} ${strip(medium?.event?.name)}`,
        [medium.event],
      );
    const meta = [
        {
            property: 'og:type',
            content: 'article',
        },
        {
            property: 'og:tag',
            content: 'sponsored',
        },
        {
            property: 'og:title',
            content: metaTitle,
        },
        {
            property: 'og:description',
            content: share?.message,
        },
        {
            property: `og:${assetType}`,
            content: medium?.asset?.url,
        },
        {
            property: 'twitter:card',
            content: `${assetType === 'video' ? 'player' : 'summary_large_image'}`,
        },
        {
            property: 'twitter:title',
            content: metaTitle,
        },
        {
            property: 'twitter:description',
            content: share?.message,
        },
        {
            property: `twitter:${assetType === 'video' ? 'player' : 'image'}`,
            content: medium?.asset?.url,
        },
    ];
    const [metaData] = useState(meta);
    return (
      <Main
        viewer={viewer}
        meta={metaData}
      />
    );
}

SocialSharePage.propTypes = {
    viewer: PropTypes.object.isRequired,
};

export default SocialSharePage;
